import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const coverSizes = {
    small: 'h-[200px]',
    medium: 'h-[280px]',
    large: 'h-[340px]',
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block"
      data-product-shop
    >
      <div className={`relative ${coverSizes[size]} rounded-lg overflow-hidden bg-background-200`}>
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩国漫画在线阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-white text-sm font-medium whitespace-nowrap truncate w-full">
            {comic.title}
          </span>
        </div>
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 bg-accent-500 text-xs text-white px-2 py-0.5 rounded-full whitespace-nowrap">
            连载
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 bg-secondary-600 text-xs text-white px-2 py-0.5 rounded-full whitespace-nowrap">
            完结
          </span>
        )}
      </div>
      <div className="mt-2 px-0.5">
        <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">
          {comic.author}
        </p>
        {size !== 'small' && (
          <div className="flex items-center gap-2 mt-1">
            <span className="flex items-center text-xs text-amber-500">
              <i className="ri-star-fill text-xs mr-0.5"></i>
              {comic.rating}
            </span>
            <span className="text-xs text-foreground-400">{comic.views}</span>
          </div>
        )}
      </div>
    </Link>
  );
}